<form [formGroup]="form">
  <mat-form-field appearance="outline">
    @if (!hideLabel) {
      <mat-label>
        @if (!autoTranslate) {
          <span>{{labelName}}</span>
        }
        @if (autoTranslate) {
          <mwp-text-translate [text]="labelName" [jsonKey]="labelName" />
        }
      </mat-label>
    }
    <textarea matInput [formControlName]="nameForControl" [ngStyle]="{ 'height': height }"></textarea>
  </mat-form-field>
</form>